<template>
  <button @click="modalsSetShow('Login')" class="auth-button">
    <!-- Sol üstte taşıyıcı gif -->
    <img src="@/assets/img/gift.gif" alt="Gift" class="gift-badge" />

    <div class="button-inner">
      <IconRoblox />
      {{ $t('mainte.3') }}
    </div>
  </button>
</template>

<script>
    import { mapActions } from 'vuex';
    import IconRoblox from '@/components/icons/IconRoblox';

    export default {
        name: 'AuthButton',
        components: {
            IconRoblox
        },
        methods: {
            ...mapActions(['modalsSetShow'])
        }
    }
</script>

<style scoped>
button.auth-button {
  height: 37px;
  position: relative; /* gerekli */
      right: 30px;
}

button.auth-button .button-inner {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 22px;
  font-size: 12px;
  font-weight: 800;
  color: #000;
      background: var(--buttonyellow);
    box-shadow: rgb(197, 106, 24) 0px -3px 0px 0px inset, rgb(255, 234, 47) 0px 2px 0px 0px inset;
  border-radius: 5px;
  position: relative;
  z-index: 1;
}

button.auth-button .button-inner svg {
  margin-right: 11px;
  fill: #000;
}

.gift-badge {
  position: absolute;
  top: -10px;
  right: -10px;
  width: 30px;
  height: 30px;
  pointer-events: none;
  z-index: 2;
}

</style>
